import { Injectable } from '@angular/core';

const compareColumns = 5;
const ambitionLevelMax = 3;

@Injectable()
export class Globals {
  styles = {
    alertClass: 'alert',
    alertBottomClass: 'alert-bottom',
    errorClass: 'message-error'
  };
  compareColumns: number = compareColumns;
  ambitionLevelMax: number = ambitionLevelMax;
}



// WEBPACK FOOTER //
// ./src/globals.ts